import React__default, { useRef, useEffect } from 'react';
import Jazzicon from '@metamask/jazzicon';
import { sizes, Layout, Image } from './styles.js';
import { AvatarSizes } from './types.js';

var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? AvatarSizes.MEDIUM : _b, hash = _a.hash, image = _a.image, alt = _a.alt, id = _a.id;
    var placeholderRef = useRef(null);
    var sizeVal = typeof size === "number" ? size : sizes[size];
    useEffect(function () {
        if (!image && placeholderRef.current && hash) {
            placeholderRef.current.innerHTML = "";
            placeholderRef.current.appendChild(Jazzicon(sizeVal, parseInt(hash.slice(2, 10), 16)));
        }
    }, [image, hash, size]);
    return (React__default.createElement(Layout, { size: sizeVal, "data-testid": "avatar-view", id: id }, image ? (React__default.createElement(Image, { src: image, alt: alt })) : (React__default.createElement("div", { "data-testid": "icon-input", ref: placeholderRef }))));
};

export { AvatarSizes, Avatar as default };
